export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-filled-57a55996bc6458539aafca9419dcfeb9.svg";